import axios from 'axios'
import store from '../store'
import { getToken } from '../utils/auth'


const service = axios.create({
        // baseURL: "http://39.107.71.84:18868/api/", //请求基础地址
        baseURL: "https://fw.guoli315.com/api/", //请求基础地址

        // baseURL: "/api/", //请求基础地址跨域
        timeout: 50000
    })
    // 添加请求拦截器
service.interceptors.request.use(
        config => {
            // if (store.getters.laravel_session) {
            // console.log(getToken())
            //   config.headers['laravel_session'] = getToken()
            // }

            return config
        },
        error => {
            return Promise.reject(error)
        }
    )
    // 添加返回拦截器
service.interceptors.response.use(
    response => {
        const res = response.data

        const a = parseInt(res.status)

        if (res.code != 200) {
            // Message({
            //   message: res.message || 'Error',
            //   type: 'success',
            //   duration: 5 * 1000
            // })
            if (a === 100 || a === 50012 || a === 50014) {
                // to re-login
                // MessageBox.confirm(res.message, {
                //   confirmButtonText: '重新登录',
                //   cancelButtonText: '取消',
                //   type: 'warning'
                // }).then(() => {
                // store.dispatch('user/resetToken').then(() => {
                //   location.reload()
                // })
                // })
            }
            // return Promise.reject(new Error(res.msg || 'Error'))
            return res
        } else {
            // Message({
            // message: res.message,
            // type: 'success',
            // duration: 5 * 1000
            // })
            return res
        }
    },
    error => {
        // console.log('err' + error) // for debug
        // Message({
        //   message: error.message,
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        // return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js